// TODO: HE-5374 Remove this file
export enum CoverageLevelNames {
	Employee = 'Employee',
	EmployeeAndSpouse = 'Employee + Spouse',
	EmployeeAndChildren = 'Employee + Children',
	EmployeeAndFamily = 'Employee + Family',
}
